import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editScopeOfFinishing } from "../../api";
import { ScopeOfFinishing } from "../../types";

export function useEditScopeOfFinishing() {
  const queryClient = useQueryClient();

  const mutation = useMutation<
    ScopeOfFinishing,
    { response?: { data?: { message?: string } } },
    { uid: string; data: { scopeOfFinishing: ScopeOfFinishing } }
  >({
    mutationFn: ({ uid, data }) => editScopeOfFinishing(uid, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });

  return mutation;
}
